export default __webpack_public_path__ + "static/media/plus.4aa51606.svg";